@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}


<div>
  @if (AccessAllowed) {
    <div class="p-3">
      <h3>
        {{todayDate | date:'EEEE, d MMMM yyyy'}}
      </h3>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="container">
          <!-- <div class="box box5 surface-card p-4 shadow-2 border-round">
          <span style="font-size:30px;">Message Centre:</span>
          <div *ngFor="let msg of messages" [style]="getBackColour(msg)">
            {{msg.messagetext}}
          </div>
          <div *ngIf="messages.length == 0" style="text-align: center; margin-top: 20px;">
            <span style="font-size: 20px;">There are currently no messages</span>
          </div>
        </div> -->
        <div class="box box1 surface-card p-4 shadow-2 border-round" style="text-align: center;">
          <p style="font-size: 100px;">{{BookingsToday}}</p>
          <p style="font-size: 30px;margin-top:-30px;">Bookings Today</p>
          <hr style="margin-top: 39px; margin-bottom: -4px;">
          <p style="font-size: 100px;">{{AdmissionsToday}}</p>
          <p style="font-size: 30px;margin-top:-30px;">Admissions Today</p>
        </div>
        <div class="box box2 surface-card p-4 shadow-2 border-round" style="text-align: center;">
          <span style="font-size:30px">Admission Breakdown</span>
          <div style="width:100%;margin-top:20px;">
            <div style="margin: auto; width: 200px;">
              <p-chart type="pie" [data]="chartData" [options]="basicOptions" style="display:block;width:200px; height:200px;"></p-chart>
            </div>
          </div>
        </div>
        <div class="box box3 surface-card p-4 shadow-2 border-round">
          <div style="margin-bottom: 20px;font-size: 30px;">Booking this week vs last week</div>
          <div style="width:100% !important;float:left;">
            <p-chart type="bar" [data]="weeklydata" [options]="options" />
          </div>
          <div style="width:100%; clear: both;"></div>
        </div>
        <div class="box box3a surface-card p-4 shadow-2 border-round" style="padding-top: 10px !important;">
          <p-table [value]="admissionData" style="padding: 0.7rem !important"
            [showCurrentPageReport]="true" responsiveLayout="scroll"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [globalFilterFields]="['name']">
            <ng-template #header>
              <tr>
                <th style="width:60%">Admission</th>
                <th style="width:20%;text-align:right">Qty Today</th>
                <!-- <th style="width:20%;text-align:right">Value Today</th> -->
              </tr>
            </ng-template>
            <ng-template #body let-data>
              <tr>
                <td style="font-weight:bold"><span style="color: {{data.colour}}; margin-right:10px;" class="pi pi-circle-fill"></span>{{data.name}}:</td>
                <td style="text-align:right">{{data.totalnumber}}</td>
                <!-- <td style="text-align:right;font-weight:bold;">{{data.totalvalue | currency:CurrencySymbol}}</td> -->
              </tr>
            </ng-template>
            <ng-template #footer>
              <tr>
                <td style="text-align:right">Total:</td>
                <td style="text-align:right">{{TotalNumberThisWeek}}</td>
                <!-- <td style="text-align:right;font-weight:bold;">{{TotalValueThisWeek | currency:CurrencySymbol}}</td> -->
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class="box box4 surface-card p-4 shadow-2 border-round">
          <div style="margin-bottom: 20px;font-size: 30px;">Bookings to acknowledge</div>
          <p-table  #resourceTable (onPage)="paginate($event)"
            [columns]="cols"
            [value]="ListBookings" sortField="startTime"
            [(selection)]="selectedItems"
            responsiveLayout="scroll"
            [selectionPageOnly]="true">
            <ng-template #header>
              <tr>
                <th style="padding: 7px;" width="1%">
                  &nbsp;
                </th>
                <th pSortableColumn="bookingId" >Sales ID
                  <p-sorticon [field]="bookingIdHR"></p-sorticon>
                </th>
                <th style="text-align:center" pSortableColumn="startTime" >Start Date/Time
                  <p-sorticon [field]="startTime"></p-sorticon>
                </th>
                <th pSortableColumn="name" >Name
                  <p-sorticon [field]="name"></p-sorticon>
                </th>
                <th pSortableColumn="packageName">Package
                  <p-sorticon [field]="packageName"></p-sorticon>
                </th>
                <th pSortableColumn="guests">Guests
                  <p-sorticon [field]="guests"></p-sorticon>
                </th>
                <th style="text-align: center;" pSortableColumn="outstanding">Total<br>O/S
                  <p-sorticon [field]="outstanding"></p-sorticon>
                </th>
                <th style="padding: 3px;" width="1%"></th>
              </tr>
            </ng-template>
            <ng-template #body let-data>
              @if (!data.inProgress && !inProgress) {
                <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}"  onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                  <td style="padding: 7px;" (click)="editdatanew(data.bookingId)" >
                    @if (data.publicBooking) {
                      <div class="pi pi-user"></div>
                    }
                    @if (data.extraslist != '' && data.extraslist != null) {
                      <div class="pi pi-star-fill"></div>
                    }
                    @if (data.allergy != '' && data.allergy != null) {
                      <div class="pi pi-asterisk"></div>
                    }
                    @if (data.notes != '' && data.notes != null) {
                      <div style="color:red" class="pi pi-exclamation-circle"></div>
                    }
                  </td>
                  <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                  <td (click)="editdatanew(data.bookingId)" style="text-align: center;">
                    <div>{{data.startTime | date:'dd/MM/yy'}}</div>
                    <div>{{data.startTime | date:'HH:mm' : 'UTC'}}</div>
                  </td>
                  <td (click)="editdatanew(data.bookingId)">{{data.name}}</td>
                  <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                  <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                  <td (click)="editdatanew(data.bookingId)">
                    <div style="text-align: center;">{{data.total | currency: CurrencySymbol}}</div>
                    @if (data.outstanding <=0) {
                      <div style="text-align: center;">
                        {{data.outstanding | currency: CurrencySymbol}}
                      </div>
                    }
                    @if (data.outstanding > 0) {
                      <div style="text-align: center;">
                        <span style="color: Red; font-weight: bold;">{{data.outstanding | currency: CurrencySymbol}}</span>
                      </div>
                    }
                  </td>
                  @if (data.disabled) {
                    <td style="padding: 3px;"><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="undisableData(data.bookingId)" i18>
                      <span class="pi pi-check-circle"></span>
                    </button></td>
                  }
                  @if (data.disabled) {
                    <td>
                    </td>
                  }
                  <td style="padding: 3px;">@if (!data.acknowledged && data.disabled!=true) {
                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="acknowledge(data.bookingId)" i18>
                      <span class="pi pi-thumbs-up"></span>
                    </button>
                  }</td>
                </tr>
              }
              @if (data.inProgress && inProgress) {
                <tr style="background-color: #FCE1B5;">
                  <td>
                    @if (data.publicBooking) {
                      <span class="pi pi-user"></span>
                    }
                  </td>
                  <td>
                    @if (data.notes != '' && data.notes != null) {
                      <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                    }
                  </td>
                  <td style="font-style: italic;">{{data.bookingIdHR}}</td>
                  <td style="font-style: italic;">{{data.startTime | date:'dd/MM/yy'}}</td>
                  <td style="font-style: italic;">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                  <td style="font-style: italic;">{{data.name}}</td>
                  <td style="font-style: italic;">{{data.packageName}}</td>
                  <td style="font-style: italic;">{{data.guests}}</td>
                  <td style="font-style: italic;">{{data.total | currency: CurrencySymbol}}</td>
                  <td style="font-style: italic;">{{data.outstanding | currency: CurrencySymbol}}</td>
                  @if ((data.paymentlinksentdate | date:'dd/MM/yy HH:mm') != '01/01/01 00:00') {
                    <td style="font-style: italic; text-align: centre;">{{data.paymentlinksentdate | date:'dd/MM/yy HH:mm'}}</td>
                  }
                  @if ((data.paymentlinksentdate | date:'dd/MM/yy HH:mm') == '01/01/01 00:00') {
                    <td style="font-style: italic; text-align: centre;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;--</td>
                  }
                  <td style="font-style: italic;">{{data.expiry | date:'HH:mm:ss'}}</td>
                  <td>
                    @if (!data.publicBooking) {
                      <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="abandonBooking(data.bookingId)" i18>
                        <span class="pi pi-times"></span>
                      </button>
                    </td>
                  }
                  @if (data.publicBooking) {
                    <td>
                    </td>
                  }
                  <td>
                  </td>
                  <td>
                  </td>
                </tr>
              }
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
}</div>